export const STRING_SHORT_MAX_LENGTH = 50;
export const STRING_LONG_MAX_LENGTH = 255;
export const NOTIFICATION_TITLE_MAX_LENGTH = 110;
export const NOTIFICATION_CONTENT_MAX_LENGTH = 255;
export const PASSWORD_MIN_LENGTH = 8;
export const PASSWORD_MAX_LENGTH = 50;
export const REJECT_MEMBERSHIP_REASON_MAX_LENGTH = 500;
